import React from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white shadow sticky top-0 z-50">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-gray-900 hover:text-blue-600">
          Julianne Lee
        </Link>
        <div className="hidden md:flex gap-8 items-center">
          <a href="/#projects" className="text-gray-600 hover:text-gray-900">Projects</a>
          <a href="/#ai-work" className="text-gray-600 hover:text-gray-900">AI Work</a>
          <a href="/#contact" className="text-gray-600 hover:text-gray-900">Contact</a>
          <a 
            href="/JulianneLee_Resume.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition font-semibold"
          >
            Resume
          </a>
        </div>
      </nav>
    </header>
  );
}
